import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";

const MultiSelectAndSearch = ({
  optionsData,
  data,
  setData,
  isMultiSelect = true,
  error,
  required
}) => {
  const [selectedOptions, setSelectedOptions] = useState(data);

  const handleChange = (value) => {
    setSelectedOptions(value);
    setData(value);
  };

  useEffect(() => {
    setSelectedOptions(data);
  }, [data]);

  return (
    <Autocomplete
      multiple={isMultiSelect}
      disableCloseOnSelect={isMultiSelect}
      id={`tags-outlined-${optionsData?.value}`}
      className="preference-attribute-select"
      options={
        isMultiSelect
          ? optionsData?.menuItems || []
          : optionsData?.menuItems.filter(
              (item) => item !== selectedOptions[0]
            ) || []
      }
      value={isMultiSelect ? selectedOptions : selectedOptions[0] || null}
      onChange={(event, newValue) => {
        if (isMultiSelect) {
          handleChange(newValue);
        } else {
          handleChange(newValue ? [newValue] : []);
        }
      }}
      getOptionLabel={(option) => option}
      filterSelectedOptions={isMultiSelect}
      renderInput={(params) => (
        <TextField
          {...params}
          label={optionsData?.label}
          error={error}
          helperText={error}
          required={required}
        />
      )}
    />
  );
};

export default MultiSelectAndSearch;
